import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SuperadminLayout, { DarkCard } from "./SuperadminLayout";
import { Badge } from "@/components/ui/badge";

const EVT_LABEL = {
  "questionnaire.send": "Questionnaire envoyé",
  "auth.forgot.sent": "Reset password",
  "cabinet.invite": "Invitation cabinet",
  "org.invitation.sent": "Invitation établissement",
  "superadmin.user.send_reset": "Reset (via superadmin)",
};

export default function SuperadminEmails() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/superadmin/emails");
        setItems(data.items);
      } finally { setLoading(false); }
    })();
  }, []);
  return (
    <SuperadminLayout title="Journal des envois email">
      <p className="text-sm text-[#8494A8] mb-4">
        Extrait des évènements <code className="text-[#B0C97F]">audit_log</code> — les envois email transitent par Resend via l'intégration Emergent. La délivrabilité complète est consultable dans le dashboard Resend.
      </p>
      <DarkCard className="overflow-hidden" data-testid="emails-table">
        <table className="w-full text-sm">
          <thead className="bg-white/[0.03] text-[#8494A8]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Type</th>
              <th className="text-left px-4 py-3 font-medium">Destinataire / Cible</th>
              <th className="text-left px-4 py-3 font-medium">Origine</th>
              <th className="text-left px-4 py-3 font-medium">Horodatage</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="p-8 text-center text-[#8494A8]">Chargement…</td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-[#8494A8]">Aucun envoi tracé</td></tr>}
            {items.map((it, i) => (
              <tr key={i} className="border-t border-white/5 hover:bg-white/[0.03]">
                <td className="px-4 py-3">
                  <Badge className="bg-white/10 text-white/80 hover:bg-white/10">{EVT_LABEL[it.event] || it.event}</Badge>
                </td>
                <td className="px-4 py-3 text-[#B7C4D6] text-xs break-all">
                  {it.extra?.email || it.extra?.target_email || it.resource_id || "—"}
                </td>
                <td className="px-4 py-3 text-[#B7C4D6] text-xs break-all">
                  {it.user_email || "—"}
                </td>
                <td className="px-4 py-3 text-[#8494A8] text-xs whitespace-nowrap">
                  {new Date(it.at).toLocaleString("fr-FR")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </DarkCard>
    </SuperadminLayout>
  );
}
